module.exports = __webpack_public_path__ + "static/img/serviceResources.b311e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthMonitoring/serviceResources.png
// module id = 69nn
// module chunks = 1